export function formatNumberIndianStyle(number: number) {
  return new Intl.NumberFormat("en-IN").format(number);
}

export function toRupees(amount: number) {
  return `₹${toIndianNumber(amount)}`;
}

export function toIndianNumber(amount: number) {
  return formatNumberIndianStyle(amount);
}

export function maskPhoneNumber(phoneNumber: string) {
  return phoneNumber.replace(/\d{6}/, "******");
}

// Returns the value as integer if no fraction digits, else rounds to max two fraction digits
export function toDisplayNumber(value: number): string {
  if (Number.isInteger(value)) {
    return value.toString();
  }
  return value.toFixed(2).replace(/\.00$/, "");
}
